import React from 'react';
import classes from './StepsCards.module.css';
import { ReactComponent as Seed } from '../../assets/seedling.svg';
import { ReactComponent as Chart } from '../../assets/chart.svg';
import { ReactComponent as Rocket } from '../../assets/rocket.svg';
import { ReactComponent as Hands } from '../../assets/hands.svg';
import { useState } from "react";
import { Button, Collapse, Box, VStack } from "@chakra-ui/react";


const StepsCards = () => {
  const [showSteps, setShowSteps] = useState(false);
    const steps = [
        {
          title: "Why This Project Exists?",
          description: "This project was created as a way to secure my child's financial future. By tracking cryptocurrency investments and small rewards earned from games, as well as future investments in stocks and dividends, I hope to build a stable foundation for my son, Mattias.",
        },
        {
          title: "What Investments Are Tracked?",
          description: "The investments tracked on this site include cryptocurrencies like Bitcoin, Ethereum, and Litecoin, alongside small contributions from play-to-earn games and other rewards. In the future, this portfolio will expand to include traditional investments like stocks and dividends.",
        },
        {
          title: "The Ultimate Goal",
          description: "My ultimate goal is to create a long-term investment fund that will provide Mattias with opportunities for education, personal growth, and financial security when he becomes an adult.",
        },
        {
          title: "Transparency and Contributions",
          description: "This site is also designed for transparency. All wallet addresses and balances are publicly displayed for anyone interested in contributing to this fund. Donations are optional, as the primary focus is on managing and tracking the investments made for Mattias' future.",
          icon: `<Chart />`
        },
      ];

  return (
    <Box textAlign="center" py={5}>
    <Button onClick={() => setShowSteps(!showSteps)} colorScheme="blue" mb={4}>
      {showSteps ? "Show Less" : "More About This Project"}
    </Button>

    <Collapse in={showSteps} animateOpacity>
      <VStack spacing={4} align="stretch">
    <div className={classes.content}>
      <ul className={classes.team}>
        {steps.map((step, index) => (
          <li className={classes.member} key={index}>
            <div className={classes.thumb}>
            {index === 0 && <Seed />}
            {index === 1 && <Chart />}
            {index === 2 && <Rocket />}
            {index === 3 && <Hands />}
            </div>
            <div className={classes.description}>
              <h3>{step.title}</h3>
              <p>{step.description}</p>
            </div>
          </li>
        ))}
      </ul>
    </div>
    </VStack>
      </Collapse>
    </Box>
  )
}

export default StepsCards